import React from 'react';
import PropTypes from 'prop-types';
import ProcessingBanner from './ProcessingBanner';
import CompletedBanner from './CompletedBanner';
import FailedBanner from './FailedBanner';
import './index.css';

const taskStatusBannersDefaultPropTaskStatusData = [];
const taskStatusBannersDefaultPropOnRetryTask = () => {};
const TaskStatusBanners = ({
  taskStatusData = taskStatusBannersDefaultPropTaskStatusData,
  onDismissTask,
  onRetryTask = taskStatusBannersDefaultPropOnRetryTask
}) => {
  if (!taskStatusData || taskStatusData.length === 0) {
    return null;
  }

  // Group statuses
  const hasProcessingOrWaiting = taskStatusData.some(
    item => item.status === 'PROCESSING' || item.status === 'WAITING'
  );

  // Get COMPLETED and FAILED items together, sorted by createdAt
  const completedAndFailedItems = taskStatusData
    .filter(item => item.status === 'COMPLETED' || item.status === 'FAILED')
    .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));

  const banners = [];

  // Processing/Waiting banner
  if (hasProcessingOrWaiting) {
    banners.push(<ProcessingBanner key="processing" />);
  }

  // Completed and Failed banners
  const statusBanners = completedAndFailedItems.map(item => {
    if (item.status === 'COMPLETED') {
      return (
        <CompletedBanner
          key={`completed-${item.id}`}
          item={item}
          onDismiss={() => onDismissTask(item.id, item.cropSeasonId)}
        />
      );
    }
    if (item.status === 'FAILED') {
      return (
        <FailedBanner
          key={`failed-${item.id}`}
          item={item}
          onRetry={() => onRetryTask(item.id, item.cropSeasonId)}
          onDismiss={() => onDismissTask(item.id, item.cropSeasonId)}
        />
      );
    }
    return null;
  });

  banners.push(...statusBanners);

  return <div className="task-status-banners">{banners}</div>;
};

TaskStatusBanners.propTypes = {
  taskStatusData: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      status: PropTypes.oneOf(['PROCESSING', 'WAITING', 'COMPLETED', 'FAILED']),
      actionType: PropTypes.oneOf(['ADD', 'DELETE', 'EDIT']),
      createdAt: PropTypes.string,
      cropSeasonId: PropTypes.string,
      otherFields: PropTypes.shape({
        cropName: PropTypes.string,
        yieldName: PropTypes.string
      })
    })
  ),
  onDismissTask: PropTypes.func.isRequired,
  onRetryTask: PropTypes.func
};

export default TaskStatusBanners;
